// Ensure global functions exist
if (typeof window.fetchConfig === 'undefined') {
  window.fetchConfig = function(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  };
}

// Ensure routes exist
if (typeof window.routes === 'undefined') {
  window.routes = {
    cart_add_url: '/cart/add',
    cart_url: '/cart'
  };
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var config = window.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      const idInput = this.form.querySelector('[name=id]');
      if (idInput && idInput.dataset.skipCart && idInput.dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Only call publish if it exists
          if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});

            // Only call publish if it exists
if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
}


          }
          
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                } else {
                  // Fallback to opening cart drawer directly
                  this.openCartDrawer();
                  if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
}
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            } else {
              // Fallback to opening cart drawer directly
              this.openCartDrawer();
            }
          }
        })
        .catch((e) => {
          console.error('Add to cart error:', e);
          this.handleErrorMessage('Unable to add item to cart. Please try again.');
          // Ensure button is re-enabled even if there's an error
          this.resetButtonState();
        })
        .finally(() => {
          this.resetButtonState();
        });
    }

    openCartDrawer() {
      // Try to open the cart drawer directly
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        // Fallback to redirecting to cart page
        window.location = window.routes.cart_url;
      }
    }

    resetButtonState() {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}